import { Component, inject } from '@angular/core';
import { RestaurantService } from '../../../services/restaurant.service';
import { FNFResponse } from '../../../models/response';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import {
  isPlatformSupportUser,
  PLATFORM_SUPPORT_DEFAULT_ROUTE,
} from '../../../utils/user-role.util';
import { SquareResyncService } from '../../../services/square-resync.service';

@Component({
  selector: 'app-select-restaurant',
  standalone: true,
  imports: [FormsModule, MatIcon],
  templateUrl: './select-restaurant.component.html',
  styleUrl: './select-restaurant.component.css',
})
export class SelectRestaurantComponent {
  private restaurantService = inject(RestaurantService);
  private squareResyncService = inject(SquareResyncService);
  private authService = inject(AuthService);
  private ngxSpinnerService = inject(NgxSpinnerService);
  private router = inject(Router);
  restaurants: any = [];
  showDropdown: boolean = false;
  selectedRestaurant: any = null;
  selectedRestaurantId: string = '';
  preDefinedRestaurants: any[] = [];
  filteredRestaurants: any[] = [];
  errorMessage: string = '';
  currentYear = new Date().getFullYear();

  ngOnInit() {
    this.restaurantService.getAllRestaurants().subscribe({
      next: (response: FNFResponse<any>) => {
        this.restaurants = response.data;
        this.preDefinedRestaurants = this.restaurants.map((restaurant: any) => {
          return {
            restaurant_name: restaurant.restaurant_name,
            restaurant_id: restaurant.restaurant_id,
            address: restaurant.address,
          };
        });
        this.filteredRestaurants = [...this.preDefinedRestaurants];
      },
    });
  }

  filterOptions() {
    this.errorMessage = '';
    this.showDropdown = true;
    this.filteredRestaurants = this.preDefinedRestaurants.filter((option: any) =>
      option.restaurant_name.toLowerCase().includes(this.selectedRestaurant?.toLowerCase()),
    );
  }

  hideDropdown() {
    this.showDropdown = false;
  }

  selectOption(option: any) {
    this.errorMessage = '';
    this.selectedRestaurant = option.restaurant_name;
    this.selectedRestaurantId = option.restaurant_id;
    this.showDropdown = false;
  }

  onSubmit() {
    this.authService.signInSuperAdminUser(this.selectedRestaurantId).subscribe({
      next: (response: FNFResponse<any>) => {
        if (!response.data && response.error) {
          this.errorMessage = response.error.error?.message || response.error.message;
          return;
        } else if (!response.data) {
          this.errorMessage = 'No data found!';
          return;
        } else if (response.data && response.data.access_token) {
          localStorage.removeItem('userToken');
          localStorage.removeItem('refreshToken');
          localStorage.removeItem('user');
          localStorage.setItem('userToken', response.data.access_token);
          localStorage.setItem('refreshToken', response.data.refresh_token);
          localStorage.setItem('user', JSON.stringify(response.data.user));
          this.errorMessage = '';
          this.ngxSpinnerService.hide();
          this.getCurrentRestaurantDetails();
        }
      },
      error: (error) => {
        this.errorMessage =
          'An error occurred while processing your request. Please try again later.';
        this.ngxSpinnerService.hide();
      },
    });
  }

  getCurrentRestaurantDetails() {
    this.ngxSpinnerService.show();
    this.restaurantService.getRestaurantDetails().subscribe({
      next: (response: FNFResponse<any>) => {
        if (!response.data && response.error) {
          this.ngxSpinnerService.hide();
          console.log(response.error.error?.message || response.error.message, 'Error');
          if (
            response.error.error?.message == 'Restaurant not found' ||
            response.error.error?.code == 404
          ) {
            this.router.navigate(['deactive-restaurant', 'not found']);
            return;
          }
          return;
        } else if (!response.data) {
          this.ngxSpinnerService.hide();
          console.log('No data found!', 'Error');
          return;
        }
        let currentRestaurant = response.data;
        this.restaurantService.currentRestaurantDetails$.next(currentRestaurant);
        this.restaurantService.restaurantPosProvider$.next(currentRestaurant.pos_provider);
        this.ngxSpinnerService.hide();
        this.router.navigate(
          isPlatformSupportUser() ? ['main', PLATFORM_SUPPORT_DEFAULT_ROUTE] : ['main'],
        );
        this.squareResyncService.checkAndPrompt(currentRestaurant);
      },
      error: () => {
        this.ngxSpinnerService.hide();
        console.log('Unable to complete your action. Please try again later.', 'Error');
        return;
      },
    });
  }
}
